// npm
import React, { memo } from 'react'
import {
  GatsbyImage,
  getImage,
  IGatsbyImageData,
  withArtDirection,
} from 'gatsby-plugin-image'
import { Box, styled, useMediaQuery, useTheme } from '@mui/material'

// components
import BackgroundPlx from '@atoms/plx/BackgroundPlx'
import Div100vh from '@atoms/layout/Div100vh'
import FixedHeightHeroContainer from '@atoms/hero/FixedHeightHeroContainer'

const containerStyles = {
  position: 'relative',
  overflow: 'hidden',
  color: 'white',
}

// @ts-ignore
const FullHeightContainer = styled(Div100vh)(({ theme }) => ({
  ...containerStyles,
  background: theme.palette.secondary.main,
}))

// @ts-ignore
const StyledFixedHeightHeroContainer = styled(FixedHeightHeroContainer)(
  ({ theme }) => ({
    ...containerStyles,
    background: theme.palette.secondary.main,
  })
)

const BgImage = styled(GatsbyImage)(({ theme }) => ({
  opacity: 0.45,
  [theme.breakpoints.down('md')]: {
    width: '100%',
    display: 'block',
    height: '0',
    paddingTop: '200%',
  },
}))

export interface ContentSectionBgImageWrapperProps {
  imageLandscape: IGatsbyImageData
  imagePortrait: IGatsbyImageData
  hero?: boolean
  isFirstSection?: boolean
  children?: React.ReactNode
}

const ContentSectionBgImageWrapper = ({
  imageLandscape,
  imagePortrait,
  hero,
  isFirstSection,
  children,
}: ContentSectionBgImageWrapperProps) => {
  const theme = useTheme()
  const mdDown = useMediaQuery(theme.breakpoints.down('md'))
  const sectionTextVariant = 'centered'

  const images = withArtDirection(
    // @ts-ignore
    getImage(imageLandscape),
    [
      {
        media: `(max-width: ${theme.breakpoints.values.md}px)`,
        image: getImage(imagePortrait),
      },
    ]
  )

  let parallaxValues = {
    startValue: isFirstSection || hero ? 0 : -50,
    endValue: 50,
  }
  if (mdDown) {
    parallaxValues = {
      ...parallaxValues,
      endValue: 50,
    }
  }

  const parallaxData = [
    {
      start: 'self',
      end: 'self',
      endOffset: '200vh',
      properties: [
        {
          ...parallaxValues,
          property: 'translateY',
          unit: 'vh',
        },
      ],
    },
  ]

  const content = (
    <Box bgcolor="common.black" height="100%">
      <BackgroundPlx parallaxData={parallaxData}>
        <BgImage image={images} alt="" />
      </BackgroundPlx>
      {children}
    </Box>
  )

  return (
    <>
      {hero ? (
        <StyledFixedHeightHeroContainer>
          {content}
        </StyledFixedHeightHeroContainer>
      ) : (
        <FullHeightContainer>{content}</FullHeightContainer>
      )}
    </>
  )
}

export default memo(ContentSectionBgImageWrapper)
